import { Outlet, useParams } from 'react-router';

import { getEvent } from '@/data/events';
import { EventProvider } from '@/contexts/EventContext';
import { NotFoundPage } from '@/pages/NotFoundPage';

/**
 * Layout for the year-scoped section (`/:year/...`). Validates the `:year` param and
 * supplies the active event via context. An unknown or non-numeric year renders the
 * 404 page. The year's theme is applied higher up, in RootLayout, so the whole
 * chrome (nav included) is themed consistently.
 */
export function EventLayout() {
  const { year } = useParams();
  const event = year && /^\d+$/.test(year) ? getEvent(Number(year)) : undefined;

  if (!event) {
    return <NotFoundPage />;
  }

  return (
    <EventProvider value={event}>
      <Outlet />
    </EventProvider>
  );
}
